import type { ViewStyle } from "react-native";
import type { AnimatedStyle } from "react-native-reanimated";
import { StyleSheet, UnistylesRuntime } from "react-native-unistyles";

import opacity from "$src/core/utils/color/opacity";

export const progressFillTransition: AnimatedStyle<ViewStyle> = {
  transitionProperty: "width",
  transitionDuration: "400ms",
  transitionTimingFunction: "ease-out",
};

const stylesheet = StyleSheet.create(({ spacing, colors, border }) => ({
  content: {
    width: "100%",
    alignSelf: "stretch",
    gap: spacing(4),
  },
  panel: {
    borderRadius: border.radius.lg,
    backgroundColor: opacity(colors.backgroundSurface, 0.2),
    overflow: "hidden",
  },
  nowPlayingCard: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: opacity(colors.foregroundDefault, 0.08),
    overflow: "hidden",
  },
  nowPlayingContent: {
    flexDirection: "row",
    alignItems: "stretch",
    gap: spacing(4),
    padding: spacing(4),
  },
  nowPlayingCover: {
    height: spacing(20),
    aspectRatio: 3 / 4,
    borderRadius: border.radius.md,
    backgroundColor: colors.backgroundDefault,
    overflow: "hidden",
    flexShrink: 0,
  },
  nowPlayingCoverImage: {
    width: "100%",
    height: "100%",
  },
  nowPlayingBody: {
    justifyContent: "center",
    flex: 1,
    minWidth: 0,
    gap: spacing(2.5),
  },
  nowPlayingTitle: {
    color: colors.foregroundDefault,
  },
  progressRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  progressTime: {
    color: colors.foregroundDefaultMuted,
  },
  adTag: {
    alignSelf: "flex-start",
  },
  adRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing(2),
  },
  nowPlayingProgressTrack: {
    height: spacing(1.5),
    width: "100%",
    backgroundColor: colors.backgroundDefault,
    overflow: "hidden",
  },
  nowPlayingProgressFill: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    backgroundColor: colors.foregroundBrand,
  },
  controls: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: spacing(4),
    paddingBottom: spacing(4),
  },
  controlsSideStart: {
    flex: 1,
    alignItems: "flex-start",
  },
  controlsSideEnd: {
    flex: 1,
    alignItems: "flex-end",
  },
  transportControls: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: spacing(2),
  },
}));

const initialTheme = UnistylesRuntime.getTheme();

export const IMAGE_DIMENSIONS = {
  cover: [
    {
      width: initialTheme.spacing(20),
      height: initialTheme.spacing(20),
    },
  ],
};

export default stylesheet;
